var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_customer",
    transform: "translate(1.500000, 1.500000)",
    fill: "#A3B3C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,12.1294118 L7.94117647,10.0117647 C8.89411765,9.27058824 9.52941176,8.21176471 9.52941176,6.94117647 L9.52941176,6.09411765 C9.52941176,4.08235294 8.04705882,2.28235294 6.03529412,2.17647059 C3.91764706,2.07058824 2.11764706,3.76470588 2.11764706,5.88235294 L2.11764706,6.94117647 C2.11764706,8.21176471 2.75294118,9.27058824 3.70588235,10.0117647 L0.847058824,12.2352941 C0.317647059,12.6588235 0,13.2941176 0,13.9294118 L0,15.9411765 C0,16.5764706 0.423529412,17 1.05882353,17 L10.5882353,17 C11.2235294,17 11.6470588,16.5764706 11.6470588,15.9411765 L11.6470588,13.8235294 C11.6470588,13.1882353 11.3294118,12.5529412 10.8,12.1294118 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9882353,6.83529412 L14.0823529,5.56470588 C14.5058824,5.14117647 14.8235294,4.50588235 14.8235294,3.76470588 L14.8235294,2.81176471 C14.8235294,1.54117647 13.8705882,0.270588235 12.6,0.0588235294 C11.3294118,-0.152941176 10.2705882,0.588235294 9.74117647,1.54117647 C10.9058824,2.6 11.6470588,4.08235294 11.6470588,5.77647059 L11.6470588,6.83529412 C11.6470588,7.78823529 11.4352941,8.74117647 11.0117647,9.48235294 C11.0117647,9.48235294 12.2823529,10.4352941 12.2823529,10.5411765 L15.8823529,10.5411765 C16.5176471,10.5411765 16.9411765,10.1176471 16.9411765,9.48235294 L16.9411765,8.63529412 C16.9411765,7.89411765 16.6235294,7.25882353 15.9882353,6.83529412 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomer);
export default __webpack_public_path__ + "static/media/icon_customer.b45705c9.svg";
export { ForwardRef as ReactComponent };